import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

const PlicBooksSuccessIcon = ({ color = '#5cb85c', size = 38, ...props }) => (
  <svg
    width={size}
    viewBox="0 0 54 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <defs>
      <path
        id="a"
        d="m9.671 0 1.788 1.8v.355L4.614 9H4.26L0 4.74v-.354l1.8-1.788h.355L4.436 4.88 9.316 0z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        d="M49.652.5c.966 0 1.841.392 2.475 1.025A3.489 3.489 0 0 1 53.152 4v12c0 .966-.392 1.841-1.025 2.475a3.489 3.489 0 0 1-2.475 1.025H4a3.489 3.489 0 0 1-2.475-1.025A3.489 3.489 0 0 1 .5 16V4c0-.966.392-1.841 1.025-2.475A3.489 3.489 0 0 1 4 .5Z"
        stroke={color}
        className="icon-force-fill-none"
      />
      <path
        d="M4 5.126h4.522c1.101 0 1.958.266 2.569.798s.917 1.255.917 2.17c0 .905-.308 1.626-.924 2.163-.616.537-1.47.805-2.562.805H6.184v4.032H4V5.126Zm4.242 4.27c1.139 0 1.708-.43 1.708-1.288 0-.868-.57-1.302-1.708-1.302H6.184v2.59h2.058Zm5.208 5.698V5.126h2.184v8.19h4.452v1.778H13.45Zm7.966 0V5.126H23.6v9.968h-2.184Zm8.862.126c-1.008 0-1.888-.212-2.639-.637a4.296 4.296 0 0 1-1.729-1.792c-.401-.77-.602-1.668-.602-2.695 0-1.017.2-1.911.602-2.681a4.252 4.252 0 0 1 1.729-1.785C28.39 5.21 29.27 5 30.278 5c.663 0 1.295.1 1.897.301.602.2 1.094.483 1.477.847l-.686 1.568a5.114 5.114 0 0 0-1.309-.735 3.891 3.891 0 0 0-1.337-.231c-.896 0-1.582.285-2.058.854-.476.57-.714 1.4-.714 2.492 0 1.101.238 1.939.714 2.513.476.574 1.162.861 2.058.861.467 0 .912-.077 1.337-.231a5.114 5.114 0 0 0 1.309-.735l.686 1.568c-.383.364-.875.646-1.477.847a5.96 5.96 0 0 1-1.897.301Z"
        fill={color}
        fillRule="nonzero"
      />
      <use fill={color} xlinkHref="#a" transform="translate(38 5.667)" />
    </g>
  </svg>
);

PlicBooksSuccessIcon.propTypes = propTypes;

export default PlicBooksSuccessIcon;
